

import {Component, Vue} from "vue-property-decorator";

import { SessionManager } from "@/components/utils/utils";

@Component
export default class CancelPage extends Vue {

    public viewStatus() {
        this.$router.push({ name: "applicant-status" });
    }
    
    public exitApplication() {
        window.open('http://www.google.ca');
        SessionManager.logoutAndRedirect(this.$store);
    }
}
